import { render } from "./BusinessRuleTable.vue?vue&type=template&id=4a9e430e"
import script from "./BusinessRuleTable.vue?vue&type=script&lang=js"
export * from "./BusinessRuleTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__